import register from '../util/init'
import 'flickity-as-nav-for'
import 'flickity-imagesloaded'
import Flickity from 'flickity'
import VideoCarousel from './VideoCarousel'
import InfScr from './infscr'
import { ajaxUrl } from '../util/ajax_util'
import {VideoPlayer} from './videoplayer'

export function initImage (image) {
  // prevent multiple initialisation
  if (image.matches('.image-initialised')) {
    return
  }

  const player = image.querySelector('.video-player')

  if (player) {
    const video = new VideoPlayer(player, {
      // handlers: {
      //   ended: () => {},
      //   playing: () => {},
      //   pause: () => {}
      // }
    })

    image.addEventListener('mouseover', e => {
      video.play()
    })
    image.addEventListener('mouseout', e => {
      video.pause()
    })
  }

  image.classList.add('image-initialised')
}

function initGalleryBlockCarousel (el) {
  const carousel = el.querySelector('.carousel')

  if (!carousel.children.length) {
    return
  }

  const flkty = new Flickity(carousel, {
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    wrapAround: true,
    dragThreshold: 30,
    prevNextButtons: false,
    pageDots: true
  })

  const pageDotsEl = carousel.querySelector('.flickity-page-dots')
  if (pageDotsEl) {
    const pageDots = pageDotsEl.querySelectorAll('.dot')
    pageDots.forEach(dot => {
      dot.style.width = `${100 / pageDots.length}%`
    })
  }

  return new VideoCarousel(flkty)
}

function initMediaCarousel (el) {
  const carousel = el.querySelector('.carousel')
  const thumbnails = el.querySelector('.thumbnails')

  if (!carousel.children.length) {
    return
  }

  const flkty = new Flickity(carousel, {
    dragThreshold: 30,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: 5000
  })
  flkty.element.focus()

  if (thumbnails) {
    new Flickity(thumbnails, {
      asNavFor: carousel,
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true
    })
    thumbnails.addEventListener('mouseenter', () => {
      flkty.pausePlayer()
    })
    thumbnails.addEventListener('mouseleave', () => {
      flkty.unpausePlayer()
    })
  }

  return new VideoCarousel(flkty)
}

function blockParent (container) {
  if (container.querySelector('.gallery-block-carousel')) {
    initGalleryBlockCarousel(container.querySelector('.gallery-block-carousel'))
  }

  const videos = container.querySelectorAll('.project-block .video-player', '.article-block .video-player')
  Array(...videos).forEach(function(videoEl) {
    const video = new VideoPlayer(videoEl, {})
  })
}
register('.work-project', blockParent)
register('.journal-article', blockParent)

function articleList (container) {
  const contentSelector = '.project-listing, .article-listing'
  const nextSelector = '.next-link'
  const content = container.querySelector('.project-list, .article-list')

  const initProjects = () => {
    const images = container.querySelectorAll(contentSelector + ' .image')
    Array(...images).forEach(initImage)
  }

  initProjects()

  const infscr = InfScr(content, {
    contentSelector: contentSelector,
    nextSelector: nextSelector,
    // autoOffset: 1500,
    cache: false, // TODO turn on cache
    get_url: (link) => {
      return ajaxUrl(link.getAttribute('href'))
    },
    beforeLoad: function () {

    },
    onLoad: function (newContent, $container) {
      initProjects()
    }
  })

  return infscr
}
register('.work-category', articleList)
register('.journal-index', articleList)



// WEBPACK FOOTER //
// ./assets/j/src/project.js